import React, { useEffect, useState } from 'react';
import ScratchCard from 'react-scratchcard';

import Modal from './Modal';
import Confetti from './confetti/confetti';
import CopyVoucher from './CopyVoucher';

function ScratchPopup({
  data,
  closeAction,
  postApi,
  image,
  orderId,
  responseData,
}) {
  const [hasScratched, setHasScratched] = useState(false);
  const [showHow, setShowHow] = useState(false);

  const settings = {
    width: 334,
    height: 286.3,
    image: image,
    finishPercent: 50,
    onComplete: () => {
      setHasScratched(true);
      postApi({ orderId, promoTypeId: data.id });
    },
  };

  const toggleModal = () => {
    setShowHow(!showHow);
  };

  return (
    <div className="Scratch">
      <div className="Scratch__Close" onClick={closeAction}>
        &#10006;
      </div>
      <ScratchCard {...settings}>
        <div className="Scratch__Prize" style={{ background: data?.color }}>
          {hasScratched && data && data.id !== -1 && <Confetti />}

          <img
            loading="lazy"
            src={data?.image}
            alt="reward"
            className="Scratch__Prize--Image"
          />
          <div className="Scratch__Prize--Text">{data?.winningText}</div>
          {responseData?.code ? (
            <CopyVoucher code={responseData?.code} />
          ) : null}
        </div>
      </ScratchCard>

      <div className="Scratch__Info">
        <div className="Scratch__Info--Text">
          {hasScratched
            ? 'Yay! You just won a reward!'
            : 'Scratch the card to reveal your reward!'}
        </div>
      </div>
      {showHow && (
        <Modal
          closeAction={toggleModal}
          howToRedeem={data && data.howToRedeem}
          termsAndConditions={data && data.termsAndConditions}
          websiteLink={data && data.websiteLink}
          websiteLink2={data && data.websiteLink2}
        />
      )}
    </div>
  );
}

export default ScratchPopup;
